module.exports = __webpack_public_path__ + "static/media/appFeePayment.205ffae6.svg";